<template>
  <div>
    <div v-for="(block, index) in blocks" :key="index">
      <center v-if="block.type === 'mermaid' && block.content.includes('is-centered')">
        <vue-mermaid-string :value="block.content"/>
      </center>
      <vue-mermaid-string v-else-if="block.type === 'mermaid'" :value="block.content" />
      <vue-markdown-render
        v-else
        :source="block.content"
        :options="{
          typographer: true,
          html: true,
          breaks: true,
          linkify: true,
          highlight: highlight,
        }"
      />
    </div>
  </div>
</template>

<script>
import VueMarkdownRender from "vue-markdown-render";
import VueMermaidString from "vue-mermaid-string";
import hljs from "highlight.js";

export default {
  name: "MermaidMarkdown",
  components: {
    VueMarkdownRender,
    VueMermaidString,
  },
  props: {
    source: {
      type: String,
      required: true,
    },
  },
  computed: {
    blocks() {
      if (!this.source) return [];

      const parts = this.source.split("```mermaid");
      return parts
        .map((part, index) => {
          if (index === 0) {
            return { type: "markdown", content: part };
          }

          const [mermaidContent, ...restContent] = part.split("```");
          return [
            {
              type: "mermaid",
              content: mermaidContent.trim(),
            },
            {
              type: "markdown",
              content: restContent.join("```").trim(),
            },
          ];
        })
        .flat()
        .filter((block) => block.content);
    },
  },
  methods: {
    highlight(str, lang) {
      if (lang && hljs.getLanguage(lang)) {
        try {
          return hljs.highlight(str, { language: lang }).value;
        } catch (__) {}
      }
      return "";
    },
  },
};
</script>

<style>

</style>
